import styled from "@emotion/styled";
import { Position } from "./FabPositioned.types";
import { Box } from "@mui/material";

const DEFAULT_FAB_POSITION_HORIZONTAL = 24;

export const FabPositionedStyled = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== "position" && prop !== "isInsideModal",
})<{ isInsideModal: boolean; position?: Position }>(
    ({ position = "right", isInsideModal = false }) => ({
        position: "fixed",
        ...(position === "center-top"
            ? {
                  top: isInsideModal
                      ? "calc(112px + var(--safe-area-inset-top))"
                      : "calc(24px + var(--safe-area-inset-top))",
              }
            : {
                  bottom: "calc(24px + var(--safe-area-inset-bottom))",
              }),
        right: position === "right" ? DEFAULT_FAB_POSITION_HORIZONTAL : "unset",
        left: position === "left" ? DEFAULT_FAB_POSITION_HORIZONTAL : "unset",
        "&.MuiFab-wrapper":
            position === "center" || position === "center-top"
                ? {
                      left: "50%",
                      transform: "translate(-50%, 0)",
                      zIndex: 5,
                  }
                : { zIndex: 5 },
        "&.MuiFab-wrapper .MuiButtonBase-root": {
            width: "3.125rem",
            height: "3.125rem",
            borderRadius: "50px",
        },

        "&.MuiFab-wrapper.MuiFab-collapse .MuiButtonBase-root": {
            transform: "scale(0)",
        },
        "&.MuiFab-wrapper.MuiFab-collapse": {
            transform: "scale(0)",
        },
    }),
);
